module.exports = __webpack_public_path__ + "static/Image1680_01@1-49d32008d2a41be0331ab54db46abdac.jpg";